import React, { useState } from 'react';
import { Button, Label } from 'reactstrap';
import Select, { components } from 'react-select';
import { useModuleTopics, ITopicOption } from 'app/shared/common-fun/useModuleTopics';

export interface ITopicFilter {
  topics: string[];
}

interface Props {
  // id of the top level topic whose sub topics are offered
  parentId: number;
  onApply: (filter: ITopicFilter) => void;
}

// Entities keep their topics as one comma separated string ("Acting, Finance")
export const filterByTopics = <T extends { topics?: string }>(items: T[], topics: string[]): T[] =>
  items.filter(item => {
    const itemTopics = (item.topics ?? '').split(',').map(topic => topic.trim());
    return topics.some(topic => itemTopics.includes(topic));
  });

const Option = props => (
  <components.Option {...props}>
    <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ marginRight: 8 }} />
    <label>{props.label}</label>
  </components.Option>
);

// Multi select topic filter with a Filter button, same as the Inspirations tab
const TopicFilter: React.FC<Props> = ({ parentId, onApply }) => {
  const { options: topicOptions } = useModuleTopics(parentId);
  const [selected, setSelected] = useState<ITopicOption[]>([]);

  const handleChange: any = (next: ITopicOption[] | null) => {
    const options = next || [];
    setSelected(options);
    // clearing the selection shows everything again straight away
    if (options.length === 0) {
      onApply({ topics: [] });
    }
  };

  return (
    <div className="mb-3 topic-filter">
      <Label className="fs-5 fw-semibold">Filter by Topics</Label>
      <div className="d-flex align-items-center gap-2">
        <div className="flex-grow-1">
          <Select
            options={topicOptions}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option }}
            value={selected}
            onChange={handleChange}
            placeholder="Select topics..."
          />
        </div>
        <Button color="primary" className="px-4 py-2 fs-6" onClick={() => onApply({ topics: selected.map(topic => topic.label) })}>
          Filter
        </Button>
      </div>
    </div>
  );
};

export default TopicFilter;
